module.exports = __webpack_public_path__ + "static/media/telecom5.1120c73d.jpg";